import React, { useContext, useEffect, useRef } from 'react';
import { Link, navigate } from 'gatsby';
import { StoreContext } from '../context/store-context';
import { slugify, priceFormatter } from '../utils/helpers';
import Close from '-!svg-react-loader!../assets/images/icons/cart-close.svg';
import CheckIcon from '-!svg-react-loader!../assets/images/icons/tick.svg';
import ArrowRight from '-!svg-react-loader!../assets/images/icons/cart-arrow.svg';
import Quantity from '../components/quantity';
import Wishlist from '-!svg-react-loader!../assets/images/icons/cart-wish.svg';
import Price from '../components/price';
import qs from 'qs';
import { gql, useQuery } from '@apollo/client';
import axios from 'redaxios';
import { StaticImage } from 'gatsby-plugin-image';
import { useAccount } from '../context/store-context';

const Cart = () => {
  const {
    wishList,
    toggleWish,
    cart,
    didJustAddToCart,
    removeLineItem,
    cartIsOpen,
    toggleCartIsOpen,
    customerAccessToken,
  } = useContext(StoreContext);
  const cartItems = cart?.lines?.nodes || [];
  const cartClose = useRef(null);
  const { userIsAuthenticated, customerData } = useAccount();

  useEffect(() => {
    if (cartIsOpen) { cartClose.current.focus() }
  }, [cartIsOpen])

  const taxTotal = priceFormatter(cart?.cost?.totalTaxAmount?.amount || 0);
  const subtotal = priceFormatter(cart?.cost?.subtotalAmount?.amount || 0);
  const total = priceFormatter(cart?.cost?.totalAmount?.amount || 0);

  const totals = [
    {
      'label': 'Subtotal',
      'value': (<span>{subtotal}</span>),
    },
    {
      'label': 'Shipping',
      'value': (<em>Calculated at checkout</em>)
    },
    {
      'label': 'Tax',
      'value': (cart?.cost?.totalTaxAmount?.amount ? <>{taxTotal}</> : <em>Calculated at checkout</em>)
    },
    {
      'label': 'Total',
      'value': (<><span className="currency">$</span>{total.replace('$', '')}</>),
    },
  ]

  const wishChecker = (shopifyId, lineId) => {

    let wish = false;
    wishList.forEach(el => {
      if (el === shopifyId) {
        wish = true
      }
    });

    const handleWish = (e) => {
      if(typeof window !== 'undefined' && !userIsAuthenticated() && !customerData) {
        navigate('/account/login');
        return null;
      } else {
        const parent = e.target.closest('.Cart__product__wish');
        if (typeof window !== `undefined`) {
          parent.classList.toggle('wished');

          if (parent.classList.contains('wished')) {
            removeLineItem(lineId);
            parent.querySelector('span').innerText = "Remove from wishlist"
          } else {
            parent.querySelector('span').innerText = "Move to wishlist"
          }
        }

        toggleWish(shopifyId)
      }
    }

    return (
      <div
        className={`Cart__product__wish ${wish ? 'wished' : ''}`}
        onClick={(e) => { handleWish(e) }}
        onKeyDown={(e) => { handleWish(e) }}
        role="presentation"
      >
        <Wishlist /> <span>{wish ? "Remove from wishlist" : "Move to wishlist"}</span>
      </div>
    )
  }

  const CUSTOMER_INFO = gql`
    query Customer($customerAccessToken: String!) {
      customer(customerAccessToken: $customerAccessToken) {
        id
        email
      }
    }
  `

  let token = customerAccessToken
  if (typeof localStorage !== 'undefined' && !token?.accessToken) {
    token = localStorage.getItem('customerAccessToken') ? JSON.parse(localStorage.getItem('customerAccessToken')) : false;
  }
  const { data } = useQuery(CUSTOMER_INFO, {
    skip: !token?.accessToken,
    variables: { customerAccessToken: token?.accessToken || '' },
  });

  const handleCheckout = () => {
    window?.dataLayer?.push({event: 'checkout_button', value: cart.cost?.totalAmount?.amount || 0})

    if (data?.customer?.email) {
      const customerData = {
        'email': data.customer !== null ? data.customer.email : '',
        'created_at': new Date().toISOString(),
        'return_to': cart.checkoutUrl,
      };

      axios({
        method: 'post',
        url: `${process.env.GATSBY_WP_URL}/wp-json/wp/v2/multipass-checkout`,
        data: qs.stringify(customerData),
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded'
        },
      }).then(result => {
        window.location = 'https://shop.lenco.supplies/account/login/multipass/' + result.data;
      }).catch(err => {
        console.error(err);
        window.location = cart.checkoutUrl;
      })
    } else {
      window.location = cart.checkoutUrl;
    }
  }

  return (
    <div className="Cart__wrapper">
      <div
        className={`Cart__overlay${cartIsOpen ? ' Cart__overlay--open' : ''}`}
        onClick={toggleCartIsOpen}
        aria-hidden="true"
      ></div>
      <div className={`Cart${cartIsOpen ? ' Cart--open' : ''}`}>

        <div className="Cart__header">
          <h3 className="Cart__title condensed">Your Cart</h3>
          <button
            className="Cart__close notbutton"
            aria-label="Close cart"
            onClick={toggleCartIsOpen}
            tabIndex={cartIsOpen ? null : '-1'}
            ref={cartClose}
          >
            <Close />
          </button>
          {didJustAddToCart && (
            <div className="Cart__message">
              <CheckIcon /> 1 item added to your cart
            </div>
          )}
        </div>

        {cartItems.length > 0 ? (<>
          <div className="Cart__products">
            {cartItems.map(line => (
              <div
                key={line.merchandise.id}
                className="Cart__product"
              >
                <Link
                  to={`/product/${line.merchandise.product.handle}`}
                  onClick={toggleCartIsOpen}
                  className="Cart__product__thumbnail"
                  tabIndex={cartIsOpen ? null : '-1'}
                >
                  {
                    line.merchandise.image ? (
                      <img
                        src={line.merchandise.image.url}
                        alt={line.merchandise.image.altText}
                        className="Cart__product__thumbnail__image"
                      />
                    ) :
                      (<StaticImage
                        src="../assets/images/scroll-logo.png"
                        alt={'product thumbnail'}
                      />)
                  }
                </Link>
                <div className="Cart__product__content">
                  <Link
                    to={`/product/${line.merchandise.product.handle}`}
                    onClick={toggleCartIsOpen}
                    className="Cart__product__title__link"
                    tabIndex={cartIsOpen ? null : '-1'}
                  >
                    <h4 className="Cart__product__title">{line.merchandise.product.title}</h4>
                  </Link>
                  {line.merchandise.title !== 'Default Title' && (
                    <div className="Cart__product__variation">
                      {line.merchandise.title}
                    </div>
                  )}
                  <button
                    className="Cart__product__remove notbutton"
                    aria-label="Remove item from cart"
                    onClick={(e) => {
                      removeLineItem(line.id);
                      e.target.closest('.Cart__product').style.opacity = '0.3';
                    }}
                    tabIndex={cartIsOpen ? null : '-1'}
                  >
                    <Close />
                  </button>
                </div>
                <div className="Cart__product__bottom">
                  <Quantity product={line} />
                  <div className="Cart__product__price">
                    <Price variant={line} cart={true} separateCurrency={true} />
                  </div>
                </div>
                {wishChecker(line.merchandise.product.id, line.id)}
              </div>
            ))}
          </div>

          <ul className="Cart__totals">
            {totals.map((total, index) => (
              <li
                key={index}
                className={`Cart__totals__item Cart__totals__item--${slugify(total.label)}`}
              >
                <div className="Cart__totals__item__label">{total.label}</div>
                <div className="Cart__totals__item__value">{total.value}</div>
              </li>
            ))}
          </ul>

          <div className="Cart__actions">
            <button
              className="Button Button__secondary"
              onClick={() => {
                handleCheckout();
                if (typeof window !== 'undefined' && window.dataLayer) {
                  // GTM ID check
                  if (window.google_tag_manager && window.google_tag_manager['GTM-P9CDNPR6']) {
                    console.log('GTM is loaded and working');
                    
                    // dataLayer check
                    if (window.dataLayer) {
                      window.dataLayer.push({
                        event: 'conversion',
                        conversionId: '743066783',
                        conversionLabel: 'jTuJCLK11Z0aEJ-ZqeIC'
                      });
                      console.log('dataLayer event sent');
                    }
                    
                    // gtag check
                    if (typeof window.gtag === 'function') {
                      window.gtag('event', 'conversion', {
                        send_to: 'AW-743066783/jTuJCLK11Z0aEJ-ZqeIC'
                      });
                      console.log('gtag event sent');
                    }
                  } else {
                    console.warn('GTM is not loaded or GTM-P9CDNTR6 not found');
                  }
                }
              }}
              tabIndex={cartIsOpen ? null : '-1'}
            >
              Proceed to Checkout <ArrowRight />
            </button>
            <div className="Cart__actions__more">
              <button
                className="notbutton Cart__actions__more__link"
                onClick={toggleCartIsOpen}
                tabIndex={cartIsOpen ? null : '-1'}
              >
                Continue Shopping
              </button>

            </div>
          </div>
        </>) : (
          <div className="Cart__empty">
            <div className="Cart__empty__message">
              Your cart is empty!
            </div>
            <button
              className="Button Button__secondary"
              onClick={toggleCartIsOpen}
              tabIndex={cartIsOpen ? null : '-1'}
            >
              Continue Shopping <ArrowRight />
            </button>
          </div>
        )}

      </div>
    </div>
  )
}

export default Cart;
